import React, { useEffect, useMemo, useRef, useState } from "react";
import CustomTable from "../../../ui/custom-table";
import { GetCheckinCheckoutapi, GetDoorAttandenceApi } from "../../../api/api";
import { SkeletonCard } from "../../../context/Customfunction";

function DoorRecord() {
  const [loading, setLoading] = useState(false);
  const [eventData, setEventData] = useState([]);
  //console.log("eventData", eventData);
  const intervalRef = useRef(null);
  const [zoomedImage, setZoomedImage] = useState(null);
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const fetchData = async () => {
    setLoading(true);
    try {
      const data = await GetDoorAttandenceApi(selectedDate);
      if (data?.data?.status === true) {
        setEventData(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();

    // intervalRef.current = setInterval(() => {
    //   fetchData();
    // }, 60000);

    // return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    fetchData();
  }, [selectedDate]);

  const cameraCards = [
    {
      label: "Door Camera",
      // image: "https://visionemptrack.greymatterz.com/stream/cam22",
      image:
        "https://visionemptrack.greymatterz.com/stream/door_control_685d1a5078b2c9ed6e6e6b4a",
    },
  ];

  return (
    <div className="d-flex fullHeightCst">
      {/* LEFT SECTION */}
      <div className="leftSection">
        <div className="titleFiltrer d-flex align-items-center p-4 border-bottom bg-white">
          <div className="col-xl-7">
            <h2 className="mb-0">Door Logs</h2>
          </div>
          <div className="col-xl-5">
            {/* <div className="d-flex gap-2">
              <div className="d-flex flex-column mt-0" style={{ minWidth: "140px" }}>
                <input
                  id="dateFilter"
                  type="date"
                  className="form-control"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>
            </div> */}
          </div>
        </div>

        <div className="p-4">
          <h5 className="mb-3">Entrance Camera Group</h5>
          <div className="cameraGrid">
            {cameraCards.map((cam, idx) => (
              <div key={idx} className="image-box bg-white">
                <img
                  src={cam.image}
                  alt={cam.label}
                  className="img-fluid"
                  // style={{ height: "200px", objectFit: "cover", width: "100%" }}
                />
                <div className="text-center py-2">{cam.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* RIGHT SECTION */}
      <div className="rightSection bg-white border-start">
        <div className="titleFiltrer d-flex align-items-center p-4 border-bottom bg-white">
          <h2>Details</h2>
        </div>

        <div className="px-3 my-3 cstHeighRight">
          {loading ? (
            Array.from({ length: 5 }).map((_, i) => <SkeletonCard key={i} />)
          ) : (
            <table className="table cstTable table-sm mb-0">
              <thead className="sticky-top" style={{ top: 0, zIndex: 1 }}>
                <tr>
                  <td>&nbsp;</td>
                  <td>Name</td>
                  <td>Door open at</td>
                </tr>
              </thead>
              <tbody>
                {eventData.map((user, idx) => (
                  <tr key={idx}>
                    <td>
                      <img
                        src={`https://visionemptrack.greymatterz.com/${user.image_dataset_path}`}
                        alt={user.name}
                        className="rounded-circle"
                        onClick={() =>
                          setZoomedImage(
                            `https://visionemptrack.greymatterz.com/${user.image_dataset_path}`
                          )
                        }
                        style={{
                          width: "75px",
                          height: "75px",
                          objectFit: "cover",
                          cursor: "zoom-in",
                        }}
                      />
                    </td>
                    <td>
                      <h3 className={user.isUnknown ? "text-danger" : ""}>
                        {user?.employee?.employee_name}
                      </h3>
                      {/* <p className="mb-0">{user.in_office === true ? "In Office" : "Out Office"}</p> */}
                    </td>
                    <td className={user.isUnknown ? "text-danger" : ""}>
                      {user.door_opened_at
                        ? new Date(user.door_opened_at).toLocaleTimeString(
                            "en-US",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            }
                          )
                        : "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      {zoomedImage && (
        <div
          className="zoomed-image-overlay"
          onClick={() => setZoomedImage(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            cursor: "zoom-out",
          }}
        >
          <img
            src={zoomedImage}
            alt="Zoomed"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              borderRadius: "8px",
              boxShadow: "0 0 20px rgba(0,0,0,0.5)",
            }}
          />
        </div>
      )}
    </div>
  );
}

export default DoorRecord;
